import {Deal, DealType, PaymentCurrencyType} from "@irati/types"
import getCurrencyForDeal from "./currency"
import isOpenValue from "./isOpenValue"

export const DealTypeLabel = {
  FLEXI_PERK: "FLEXI_PERK",
  CASHBACK: "CASHBACK",
  COMPETITION: "COMPETITION",
  PHYSICAL_GIFT: "PHYSICAL_GIFT",
  GIFT_CARD: "GIFT_CARD",
  CHARITY: "CHARITY",
  CINEMA: "CINEMA"
} as const

type DealTypeLabel = (typeof DealTypeLabel)[keyof typeof DealTypeLabel]

export const getDealTypeLabel = (deal: Deal): DealTypeLabel | null => {
  const products = deal?.productConfig?.products || []
  const dealCurrency = getCurrencyForDeal(deal)
  const isFlexiPerk = dealCurrency === PaymentCurrencyType.Tt
  const isReward = dealCurrency === PaymentCurrencyType.Rp

  const hasSalePriceValue = !isFlexiPerk && products[0]?.salePrice?.value > 0
  const isOpenValueGiftCard = isOpenValue(deal)
  const isClassicOrExternal = isReward && [DealType.Classic, DealType.External].includes(deal.type)
  const isGiftCard = hasSalePriceValue || isOpenValueGiftCard || isClassicOrExternal

  // Show Cinema UI just if all products attached are cinema products
  const isCinemaDeal = products.filter((p) => !!p.data?.cinemaMetadata?.enabled).length === products.length

  if (isFlexiPerk) return DealTypeLabel.FLEXI_PERK
  if (deal.type === DealType.Cashback) return DealTypeLabel.CASHBACK
  if (deal.type === DealType.Competition) return DealTypeLabel.COMPETITION
  if (deal.type === DealType.Merchandise) return DealTypeLabel.PHYSICAL_GIFT
  if (deal.type === DealType.Charity) return DealTypeLabel.CHARITY
  if (isCinemaDeal) return DealTypeLabel.CINEMA
  if (isGiftCard) return DealTypeLabel.GIFT_CARD

  return null
}
